import BlockWistiaVideo from './wistiaVideo'

export default BlockWistiaVideo
